import React from "react";

export const Line = ({
  color,
  size,
  thickness = "5px",
  marginTop = 0,
  onMouseUp,
  onMouseDown,
  onMouseMove,
  onMouseLeave,
  onMouseEnter,
  onClick,
  boxShadow,
  passRef,
}) => (
  <hr
    ref={passRef}
    onMouseDown={onMouseDown}
    onMouseUp={onMouseUp}
    onMouseMove={onMouseMove}
    onMouseLeave={onMouseLeave}
    onMouseEnter={onMouseEnter}
    onClick={onClick}
    style={{
      color: color,
      backgroundColor: color,
      height: thickness,
      width: size,
      border: "0px",
      borderRadius: "5px",
      display: "table-cell",
      marginTop: marginTop,
      boxShadow: boxShadow,
    }}
  />
);
